module.exports = __webpack_public_path__ + "static/media/alertTile.85b7c1c4.jpg";